// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import global from './common.vue'
import VueWechatTitle from 'vue-wechat-title'//动态修改title
Vue.use(VueWechatTitle)

Vue.prototype.GLOBAL = global
Vue.config.productionTip = false
Vue.use(ElementUI)

axios.defaults.baseURL=global.httpUrl
axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8';
Vue.use(VueAxios, axios)

Vue.directive('fo', {
  inserted (el, binding, vnode) {
    // 聚焦元素
    el.querySelector('input').focus()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js